// extracted by mini-css-extract-plugin
module.exports = {"banner":"MembershipBanner_banner__3_G_1","margin":"MembershipBanner_margin__3NoVA","subheader":"MembershipBanner_subheader__2zgOm","highlight":"MembershipBanner_highlight__2OOux"};